<template>
  <div class="content-half-mobile">
    <!-- Weekly Attendance -->
    <router-link to="/parent/attendance/daily-attendance">
      <div class="layout-menu layout-blue">
        <div class="wrap-menu">
          <div class="icon-menu">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66.6668 16.6666V41.6666M133.333 16.6666V41.6666M29.1667 75.75H170.833M183.333 158.333C183.333 164.583 181.583 170.5 178.5 175.5C175.562 180.437 171.389 184.525 166.392 187.359C161.395 190.194 155.745 191.679 150 191.667C141.583 191.667 133.917 188.583 128.083 183.333C125.5 181.167 123.25 178.5 121.5 175.5C118.328 170.337 116.654 164.393 116.667 158.333C116.667 139.917 131.583 125 150 125C160 125 168.917 129.417 175 136.333C180.359 142.41 183.322 150.231 183.333 158.333Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M137 158.333L145.25 166.583L163 150.167" stroke="#FF512F" stroke-width="8.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M175 70.8333V136.333C168.917 129.417 160 125 150 125C131.583 125 116.667 139.917 116.667 158.333C116.667 164.583 118.417 170.5 121.5 175.5C123.25 178.5 125.5 181.167 128.083 183.333H66.6667C37.5 183.333 25 166.667 25 141.667V70.8333C25 45.8333 37.5 29.1666 66.6667 29.1666H133.333C162.5 29.1666 175 45.8333 175 70.8333Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M99.9584 114.167H100.042M69.1167 114.167H69.2M69.1167 139.167H69.2" stroke="#FF512F" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="name-menu">
            Weekly<br>Attendance
          </div>
        </div>
      </div>
    </router-link>

    <a v-if="comboardPriority.value">
      <div class="layout-menu layout-green" @click="openModal('comboard')">
        <div class="wrap-menu">
          <div class="icon-menu">
            <svg width="200" height="199" viewBox="0 0 200 199" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M166.667 67.75V149C166.667 174 151.75 182.333 133.333 182.333H66.6666C48.2499 182.333 33.3333 174 33.3333 149V67.75C33.3333 40.6666 48.2499 34.4166 66.6666 34.4166C66.6666 39.5833 68.7499 44.25 72.1666 47.6666C75.5832 51.0833 80.2499 53.1666 85.4166 53.1666H114.583C124.917 53.1666 133.333 44.75 133.333 34.4166C151.75 34.4166 166.667 40.6666 166.667 67.75Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M66.6667 107.333H100M66.6667 140.667H133.333M133.333 34.4166C133.333 44.75 124.917 53.1666 114.583 53.1666H85.4167C80.2501 53.1666 75.5834 51.0833 72.1667 47.6666C68.7501 44.25 66.6667 39.5833 66.6667 34.4166C66.6667 24.0833 75.0834 15.6666 85.4167 15.6666H114.583C119.75 15.6666 124.417 17.75 127.833 21.1666C131.25 24.5833 133.333 29.25 133.333 34.4166Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="name-menu">
            Comboard<br>Priority
          </div>
        </div>
      </div>
    </a>

    <!-- Subject Attendance -->
    <!-- Sementara di hide dulu -->
    <!-- <router-link to="/parent/attendance/subject-attendance">
      <div class="layout-menu layout-green">
        <div class="wrap-menu">
          <div class="icon-menu">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.1667 150V58.3333C29.1667 25 37.5001 16.6666 70.8334 16.6666H129.167C162.5 16.6666 170.833 25 170.833 58.3333V141.667C170.833 142.833 170.833 144 170.75 145.167" stroke="#FF512F" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M66.6668 58.3334H133.333M66.6668 87.5H108.333M52.9167 125H170.833V154.167C170.833 170.25 157.75 183.333 141.667 183.333H58.3334C42.2501 183.333 29.1667 170.25 29.1667 154.167V148.75C29.1667 135.667 39.8334 125 52.9167 125Z" stroke="#FF512F" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="name-menu">
            Subject<br>Attendance
          </div>
        </div>
      </div>
    </router-link> -->

    <!-- Outstanding Invoice -->
    <router-link to="/parent/finance/invoice" class="disable-box">
      <div class="layout-menu layout-red">
        <div class="wrap-menu">
          <div class="icon-menu">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M175 58.3333V141.667C175 166.667 162.5 183.333 133.333 183.333H66.6667C37.5 183.333 25 166.667 25 141.667V58.3333C25 33.3333 37.5 16.6666 66.6667 16.6666H133.333C162.5 16.6666 175 33.3333 175 58.3333Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M120.833 37.5V54.1667C120.833 63.3333 128.333 70.8333 137.5 70.8333H154.167M66.6667 108.333H100M66.6667 141.667H133.333" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="name-menu">
            Outstanding<br>Invoice
          </div>
        </div>
      </div>
    </router-link>

    <!-- Payment Transaction -->
    <router-link to="/parent/finance/payment" class="disable-box">
      <div class="layout-menu layout-purple">
        <div class="wrap-menu">
          <div class="icon-menu">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M160.833 66V108.917C160.833 134.583 146.167 145.583 124.167 145.583H50.9167C47.1667 145.583 43.5833 145.25 40.25 144.5C38.1667 144.167 36.1667 143.583 34.3333 142.917C21.8333 138.25 14.25 127.417 14.25 108.917V66C14.25 40.3334 28.9167 29.3334 50.9167 29.3334H124.167C142.833 29.3334 156.25 37.25 159.833 55.3334C160.417 58.6667 160.833 62.0834 160.833 66Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M185.842 91V133.917C185.842 159.583 171.175 170.583 149.175 170.583H75.925C69.7583 170.583 64.175 169.75 59.3416 167.917C49.425 164.25 42.675 156.667 40.2583 144.5C43.5916 145.25 47.175 145.583 50.925 145.583H124.175C146.175 145.583 160.842 134.583 160.842 108.917V66C160.842 62.0834 160.508 58.5834 159.842 55.3334C175.675 58.6667 185.842 69.8334 185.842 91Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M39.8333 69.1667V105.833M135.183 69.1667V105.833M87.4833 109.5C93.318 109.5 98.9138 107.182 103.04 103.056C107.165 98.9305 109.483 93.3348 109.483 87.5C109.483 81.6652 107.165 76.0694 103.04 71.9436C98.9138 67.8178 93.318 65.5 87.4833 65.5C81.6485 65.5 76.0527 67.8178 71.9269 71.9436C67.8011 76.0694 65.4833 81.6652 65.4833 87.5C65.4833 93.3348 67.8011 98.9305 71.9269 103.056C76.0527 107.182 81.6485 109.5 87.4833 109.5Z" stroke="#FF512F" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="name-menu">
            Payment<br>Transaction
          </div>
        </div>
      </div>
    </router-link>

    <!-- Mobile modal menu -->
    <div class="mobile-modal" v-if="modalToOpen !== 'null'">
      <div class="header-menu" :class="modalToOpen == 'comboard' ? 'header-green' : ''">
        <p>{{ modalToOpen == 'comboard' ? 'Comboard Priority' : '' }}</p>
      </div>

      <div class="container-menu">
        <div class="container-comboard" v-if="modalToOpen == 'comboard'">
          <div class="list-comboard" v-for="(item) in comboardPriority.value" :key="item" @click="showPriority(item)">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onBeforeMount, watchEffect, computed } from 'vue'

  export default {
    props: {
      comboardPriority: { type: Object }
    },

    setup (props, { emit }) {
      const comboardPriority = reactive([])

      const modalToOpen = ref("null")
      const openModal = (data) => {
        if(data !== modalToOpen.value) {
          modalToOpen.value = data
          // document.body.style.overflowY = 'hidden'
        } else {
          modalToOpen.value = "null"
          // document.body.style.overflowY = 'auto'
        }
      }

      const showPriority = (item) => {
        emit("click-priority", item.id)
        openModal("null")
      }

      watchEffect(() => {
        comboardPriority.value = props.comboardPriority
      })

      return {
        comboardPriority,
        modalToOpen,
        openModal,
        showPriority
      }
    }
  }
</script>
